import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["children", "className", "currentIndex", "id", "mode", "size"],
    _excluded2 = ["children", "className", "id", "isActive", "isComplete", "label", "status", "stepIndex", "tooltip"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { forwardRef, Children, cloneElement, createContext, isValidElement, useContext } from 'react';
import { ThemeProvider } from 'styled-components';
import cx from 'classnames';
import { prefix } from '../../tools/settings';
import Icon from '../Icon';
import Tooltip from '../Tooltip';
import { Styled } from './ProgressTracker.styles';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
var ProgressTrackerContext = createContext();
var ProgressTracker = forwardRef(function (_ref, ref) {
  var _cx;

  var children = _ref.children,
      customClassName = _ref.className,
      currentIndex = _ref.currentIndex,
      id = _ref.id,
      mode = _ref.mode,
      size = _ref.size,
      rest = _objectWithoutProperties(_ref, _excluded);

  var className = cx((_cx = {}, _defineProperty(_cx, "".concat(prefix, "-progress-tracker"), true), _defineProperty(_cx, customClassName, !!customClassName), _cx));
  var clones = Children.map(children, function (child, index) {
    var _child$props$status, _child$props;

    if (!isValidElement(child)) return;
    return cloneElement(child, {
      status: (_child$props$status = (_child$props = child.props) === null || _child$props === void 0 ? void 0 : _child$props.status) !== null && _child$props$status !== void 0 ? _child$props$status : 'incomplete',
      stepIndex: index
    });
  });
  return _jsx(ThemeProvider, {
    theme: {
      mode: mode,
      size: size
    },
    children: _jsx(ProgressTrackerContext.Provider, {
      value: {
        currentIndex: currentIndex
      },
      children: _jsx(Styled.ProgressTracker, _objectSpread(_objectSpread({
        ref: ref,
        className: className
      }, rest), {}, {
        children: _jsx(Styled.StepList, {
          children: clones
        })
      }))
    })
  });
});
var ProgressTrackerStep = forwardRef(function (_ref2, ref) {
  var _cx2, _tooltip$isDisabled, _tooltip$position;

  var children = _ref2.children,
      customClassName = _ref2.className,
      id = _ref2.id,
      isActive = _ref2.isActive,
      isComplete = _ref2.isComplete,
      label = _ref2.label,
      status = _ref2.status,
      stepIndex = _ref2.stepIndex,
      tooltip = _ref2.tooltip,
      rest = _objectWithoutProperties(_ref2, _excluded2);

  var _useContext = useContext(ProgressTrackerContext),
      currentIndex = _useContext.currentIndex;

  var className = cx((_cx2 = {}, _defineProperty(_cx2, "".concat(prefix, "-progress-tracker__step"), true), _defineProperty(_cx2, "".concat(prefix, "-progress-tracker__step--isActive"), currentIndex === stepIndex || isActive), _defineProperty(_cx2, "".concat(prefix, "-progress-tracker__step--isComplete"), status === 'complete' || isComplete), _defineProperty(_cx2, customClassName, !!customClassName), _cx2));

  var renderContent = function renderContent() {
    return _jsxs(_Fragment, {
      children: [_jsxs(Styled.Wrapper, {
        children: [_jsx(Styled.Badge, {
          children: _jsx(Icon, {
            size: 12,
            icon: status === 'complete' || isComplete ? 'tick' : 'calendar'
          })
        }), _jsx(Styled.Number, {
          children: stepIndex + 1
        })]
      }), _jsx(Styled.Label, {
        children: label
      }), children && _jsx(Styled.Content, {
        children: children
      })]
    });
  };

  return _jsx(Styled.Step, _objectSpread(_objectSpread({
    ref: ref,
    id: id,
    className: className
  }, rest), {}, {
    children: tooltip ? _jsx(Tooltip, {
      content: typeof tooltip === 'string' ? tooltip : tooltip === null || tooltip === void 0 ? void 0 : tooltip.content,
      isDisabled: (_tooltip$isDisabled = tooltip === null || tooltip === void 0 ? void 0 : tooltip.isDisabled) !== null && _tooltip$isDisabled !== void 0 ? _tooltip$isDisabled : false,
      position: (_tooltip$position = tooltip === null || tooltip === void 0 ? void 0 : tooltip.position) !== null && _tooltip$position !== void 0 ? _tooltip$position : 'top',
      children: renderContent()
    }) : renderContent()
  }));
});
ProgressTracker.Step = ProgressTrackerStep;
export default ProgressTracker;